import system from './theme';
import { AdminRoutes } from './pages/admin/AdminRoutes';
import { Center, ChakraProvider, ProgressCircle } from '@chakra-ui/react';
import { ClientRoutes } from './pages/client/ClientRoutes';
import { createBrowserRouter, RouterProvider } from 'react-router-dom';
import { EnrollmentGate } from './pages/enrollment/EnrollmentGate';
import { HomePage } from './pages/home/HomePage';
import { LoginPage } from './pages/login/LoginPage';
import { PrivacyPolicyPage } from './pages/home/legal/PrivacyPolicyPage';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { Root } from './Root';
import { UnderageProtectionPage } from './pages/home/legal/UderageProtectionPage';

const queryClient = new QueryClient();

const loadingSpinner = (
	<Center position="fixed" inset={0} zIndex={2000} bg="whiteAlpha.800">
		<ProgressCircle.Root size="md" value={null}>
			<ProgressCircle.Circle>
				<ProgressCircle.Track />
				<ProgressCircle.Range stroke="orange.400" />
			</ProgressCircle.Circle>
		</ProgressCircle.Root>
	</Center>
);

const router = createBrowserRouter([
	{
		path: '/',
		Component: Root,
		children: [
			{
				index: true,
				Component: HomePage,
			},
			{
				path: '/polityka-prywatnosci',
				Component: PrivacyPolicyPage,
			},
			{
				path: '/ochrona-maloletnich',
				Component: UnderageProtectionPage,
			},
			{
				path: '/zapisy',
				Component: EnrollmentGate,
			},
			{
				path: '/login',
				Component: LoginPage,
			},
			{
				path: '/admin',
				children: AdminRoutes,
			},
			{
				path: '/panel',
				children: ClientRoutes,
			},
		]

	}
]);

export const Router = () => {
	return (
        <QueryClientProvider client={queryClient}>
            <ChakraProvider value={system}>
				<RouterProvider router={router} fallbackElement={loadingSpinner} />
			</ChakraProvider>
        </QueryClientProvider>
    );
};
